<div class="fixed-top container mx-auto pt-2" id="notification-container" style="z-index: 9999;">
</div>
<router-outlet></router-outlet>